import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../rootReducer';
import { updateAccountBillingContact } from './updateAccountBillingContact.thunks';

export interface UpdateAccountBillingState {
  loading: boolean;
  error: string | null;
}

export const initialState: UpdateAccountBillingState = {
  error: null,
  loading: false
};

const getForm = (state: RootState): UpdateAccountBillingState => state.users.form;

export const selectors = {
  getForm
};

const extraReducers = {
  [updateAccountBillingContact.pending.type]: (state: UpdateAccountBillingState): void => {
    state.loading = true;
    state.error = null;
  },
  [updateAccountBillingContact.fulfilled.type]: (state: UpdateAccountBillingState): void => {
    state.loading = false;
  },
  [updateAccountBillingContact.rejected.type]: (state: UpdateAccountBillingState, action: PayloadAction<string>): void => {
    state.loading = false;
    state.error = action.payload;
  }
};

const slice = createSlice({
  name: 'updateBillingContact',
  initialState,
  reducers: {},
  extraReducers
});

export default slice.reducer;

export const actions = slice.actions;
export const caseReducers = slice.caseReducers;
